module.exports = __webpack_public_path__ + "static/logo_loewy-dark-1f7786196caa328b4a717cc887b76b3b.png";